import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { testUsersApi } from '../services/testUsersApi';
import { queryKeys } from '../utils/queryKeys';

export function useTestUsers() {
  return useQuery({ queryKey: queryKeys.testUsers.list(), queryFn: testUsersApi.list });
}

export function useClearTestUserOnboarding() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (email: string) => testUsersApi.clearOnboarding(email),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.testUsers.all }),
  });
}
